import { FC, useEffect, useState } from 'react';
import { ReportSubtype } from '../../../../models/Report';
import {
  DiagnosticAssessmentTableFilters,
  filterStateDiagnosticAssessmentsInitValue,
} from '../../../AssessmentHistory/models';
import {
  filterStateSkillsAssessmentsInitValue,
  SkillAssessmentTableFilters,
} from '../../../AssessmentHistory/SkillAssessmentTable';
import { DownloadCsvDiagnosticAssessmentHistory } from '../../../AssessmentHistory/DownloadCsvDiagnosticAssessmentHistory';
import { DownloadCsvAssessmentHistoryBtn } from '../../../AssessmentHistory/DownloadCsvAssessmentHistoryBtn';
import {
  mergeDiagnosticAssessmentsHistoryFilters,
  mergeDiagnosticOustandingFilters,
  mergeProgressSkillsAssessmentsHistoryFilters,
} from '../../../../businessLogicService/mergeReportsFiltersBySubtype';
import {
  DiagnosticModalTableFilters,
  filterStateDiagnosticOutstandingInitValue,
} from '../../../AssessmentHistory/ResetAndOutstandingDiagnosticModalWrapper';
import { OutstandingResetDiagnosticCsvButton } from '../../../AssessmentHistory/OutstandingResetDiagnosticCsvButton';
import { useAppSelector } from '../../../../redux/hooks';
import { selectedReportHubFilter } from '../../../../redux/reducers/filterReportHubSlice';
import { DownloadXlsDetailedSkillReport } from '../../DownloadXlsDetailedSkillReport';

const ReportHubDownload: FC = () => {
  const reportHubFilterRedux = useAppSelector(selectedReportHubFilter);

  const [filters, setFilters] = useState<
    DiagnosticAssessmentTableFilters | SkillAssessmentTableFilters | DiagnosticModalTableFilters
  >();

  useEffect(() => {
    if (reportHubFilterRedux.selectedReportSubtype === ReportSubtype.DIAGNOSTIC_SUMMARY)
      setFilters(
        mergeDiagnosticAssessmentsHistoryFilters(
          filterStateDiagnosticAssessmentsInitValue,
          reportHubFilterRedux.values,
        ) as DiagnosticAssessmentTableFilters,
      );
    if (reportHubFilterRedux.selectedReportSubtype === ReportSubtype.DIAGNOSTIC_STUDENTS_UNFINISHED_DIAGNOSTIC)
      setFilters(
        mergeDiagnosticOustandingFilters(filterStateDiagnosticOutstandingInitValue, reportHubFilterRedux.values),
      );
    if (reportHubFilterRedux.selectedReportSubtype === ReportSubtype.PROGRESS_SKILL_ASSESSMENT_HISTORY)
      setFilters(
        mergeProgressSkillsAssessmentsHistoryFilters(
          filterStateSkillsAssessmentsInitValue,
          reportHubFilterRedux.values,
        ),
      );
  }, []);

  return (
    <>
      {reportHubFilterRedux.selectedReportSubtype === ReportSubtype.DIAGNOSTIC_SUMMARY && filters && (
        <DownloadCsvDiagnosticAssessmentHistory
          filters={filters as DiagnosticAssessmentTableFilters}
          hideButton={reportHubFilterRedux.key}
        />
      )}
      {reportHubFilterRedux.selectedReportSubtype === ReportSubtype.DIAGNOSTIC_STUDENTS_UNFINISHED_DIAGNOSTIC &&
        filters && (
          <OutstandingResetDiagnosticCsvButton
            filters={filters as DiagnosticModalTableFilters}
            totalRecords={reportHubFilterRedux.totalRecords}
            isReset={false}
            hideButton={reportHubFilterRedux.key}
          />
        )}
      {reportHubFilterRedux.selectedReportSubtype === ReportSubtype.PROGRESS_SKILL_ASSESSMENT_HISTORY && filters && (
        <DownloadCsvAssessmentHistoryBtn
          filters={filters as SkillAssessmentTableFilters}
          totalRecords={reportHubFilterRedux.totalRecords}
          hideButton={reportHubFilterRedux.key}
        />
      )}
      {reportHubFilterRedux.selectedReportSubtype === ReportSubtype.PROGRESS_DETAILED_SKILL_REPORT && (
        <DownloadXlsDetailedSkillReport />
      )}
    </>
  );
};

export default ReportHubDownload;
